import router from '@/layout/router/index.js'
import { http } from '@/public/utils/http'

export const REPORT_ACCESS_URL = 'kye-erp.com/ky-style'

// 上报反馈
export async function updateFeedback (bannerItem) {
  if (!bannerItem || bannerItem.hasFeedback) return
  const employeeNumber = window.__ERPUSER__ && window.__ERPUSER__.employeeNumber
  const params = {
    advId: bannerItem.id,
    employeeNumber,
    optTime: new Date().getTime()
  }
  await http('kuasheng.ksApplicationAdvMember.updateFeedbackFlag', params, {cancel: true, appkey: '10184'})
  bannerItem.hasFeedback = 1
}

const getUrlQuery = (fullUrl) => {
  if (!fullUrl.includes('?')) return {}
  let queryMap = {}
  const query = fullUrl.split('?')[1]
  const queryArr = query.split('&')
  queryArr.forEach(item => {
    const [key, value] = item.split('=')
    queryMap[key] = value
  })
  return queryMap
}

export async function updateRead (bannerItem) {
  if (bannerItem.hasRead) return
  const employeeNumber = window.__ERPUSER__ && window.__ERPUSER__.employeeNumber
  const params = {
    advId: bannerItem.id,
    employeeNumber,
    optTime: new Date().getTime()
  }
  await http('kuasheng.ksApplicationAdvMember.updateReadFlag', params, {cancel: true, appkey: '10184'})
  bannerItem.hasRead = 1
}

// 跨越风采图上报: 跨声要求每次都上报
export async function updateKSRead (bannerItem) {
  const query = getUrlQuery(bannerItem.accessUrl)
  const kyeStyleId = query.id || query.mediaId || query.media
  if (!kyeStyleId) return
  const params = {
    kyeStyleId,
    utmSource: 'erp_banner'
  }
  await http('kuasheng.kyeStyleRead.update', params, {cancel: true, appkey: '10184'})
  bannerItem.hasRead = 1
}

// 处理跳转
export function handleJumpTo(bannerItem) {
  const {skipType} = bannerItem
  if (skipType === 1) {
    window.erpOpen(bannerItem.accessUrl, '_blank')
  }
  if (skipType === 3) {
    router.push(bannerItem.menuCode)
  }
}


// 判断缺省图
export function isEmptyImg (bannerItem) {
  return !bannerItem.releaseType
}
// 是图片轮播图
export function isBannerImg (bannerItem) {
  return !isEmptyImg(bannerItem) && +bannerItem.releaseType === 10
}



// WEBPACK FOOTER //
// ./src/layout/pages/home/banner/utils.js